export const TOOL_UPDATE_COPY = {
  unsynced: 'There are unsynced changes',
  sync: 'Sync changes',
  retry: 'Retry sync',
  reviewHistory: 'Review tool history',
  newTool: 'New tool',
} as const satisfies Record<string, string>;
